import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { Filter } from './types';

export const defaultFilter: Filter = {
  type: QueryCombinerType.All,
  criteria: [],
};
